import React, {
    useEffect,
    useState
} from "react";
import FormElement
    from "./FormElement";
import useFormMultipleField
    from "../../../hooks/useFormMultipleField";
import useFormSelectHandlers
    from "../../../hooks/useFormSelectHandlers";
import {
    Autocomplete,
    TextField
} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const FormSelectField = ({
                             template = {},
                             values = {},
                             defaultAnswer = {},
                             onChange,
                             onBlur,
                             disabled = false,
                         }) => {
    const {hiddenLabel} = useTheme();

    const {
        options,
        answers,
        otherProps,
        otherElement,
    } = useFormMultipleField({
        template,
        values,
        defaultAnswer,
        onChange,
        disabled,
        hiddenLabel
    })

    const {
        content,
        name,
    } = template;

    const {
        ignoreIfHidden, // @TODO
        value: possibleValues,
        linkedList, // @TODO
        dataSource, // @TODO
    } = content;

    const {
        generateSelectValue
    } = useFormSelectHandlers({
        onChange,
        options
    });

    return (
        <FormElement id={template.id} hiddenLabel={hiddenLabel} label={content.question} className="fz-form-element-multiple" required={otherProps.required}>
            <div className="fz-form-field-multiple-container"
                 id={template.id}>
                <Autocomplete value={Object.keys(answers).length > 0 ? answers[Object.keys(answers)[0]] : ''}
                              autoComplete={false}
                              name={name}
                              id={template.id}
                              options={options.map((option) => option.item)}
                              onBlur={onBlur}
                              onChange={(event, newValue) => {
                                  const selectedOption = options.find((option) => {
                                      if (option.item) {
                                          return option.item === newValue;
                                      }

                                      return option === newValue;
                                  });

                                  onChange(generateSelectValue(selectedOption));
                              }}
                              renderInput={(params) => {
                                  const inputProps = {};

                                  if (hiddenLabel) {
                                      inputProps.label = content.question;
                                  }

                                  return <TextField {...params} {...inputProps} />
                              }}
                              {...otherProps}
                />
            </div>
            {otherElement(disabled)}
        </FormElement>
    )
}

export default FormSelectField;